import { Component, OnDestroy, OnInit } from '@angular/core';
import { MissionNotification } from '@classes/notification/missionNotification';
import { NotificationService } from '@services/notifications/notification.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-notification',
  templateUrl: './notification.component.html',
  styleUrls: ['./notification.component.scss']
})
export class NotificationComponent implements OnInit, OnDestroy {
  private subscription = new Subscription();
  notifications: MissionNotification[] = [];
  isLoading: boolean;

  filterValue = null;
  sortValue: string;
  // pagination: Pagination;


  constructor(
    private notificationsSrv: NotificationService
  ) { }

  ngOnInit() {
    this.initSubscriptions();
  }

  onClear(): void {
    this.notifications = [];
  }

  // redirectTo($myParam: string = ''): void {
  //   const navigationDetails: string[] = ['/miniature'];
  //   if ($myParam.length) {
  //     navigationDetails.push($myParam);
  //   }
  // }

  private initSubscriptions(): void {
    // this.notificationsSrv.getList(new PaginationRequest());

    this.subscription.add(

      this.notificationsSrv.notificationsSubject
        .subscribe(notifications => {


          this.notifications = notifications;
        })
    );

    this.subscription.add(
      // this.notificationsSrv.paginatioNotificationSubject
      // .subscribe(pagination => {
      //   this.pagination = pagination;
      // })
    );

    this.subscription.add(
      this.notificationsSrv.loadingStateChanged
        .subscribe(loadingState => {
          this.isLoading = loadingState;
        })
    );
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  // onPageChanged(pageEvent: PageEvent): void {
  //   this.pagination.pageNumber = pageEvent.pageIndex + 1;
  //   this.getList();
  // }

  // private getList(): void {
  //   const newRequest = new PaginationRequest(
  //     this.filterValue,
  //     this.sortValue,
  //     this.pagination.pageNumber,
  //     12
  //   );

  //   this.notificationsSrv.getList(newRequest);
  // }
}